<template>
    <div v-if="mostrar" class="modal-overlay">
      <div class="modal-container">
        <!-- Cabeçalho com botões -->
        <div class="modal-header">
          <h6>Pesquisa de Alunos Matriculados</h6>
          <div class="header-actions">
            <!-- Botão Adicionar Pessoa Física (opcional, se necessário) -->
            <!-- <i class="bi bi-plus-circle text-success mx-2" title="Adicionar Aluno" @click="abrirModalCadastrar"></i> -->
            <!-- Botão Fechar -->
            <i class="bi bi-x-circle close-icon" @click="$emit('fechar')"></i>
          </div>
        </div>
  
        <!-- Barra de Pesquisa (Filtros) -->
        <div class="modal-filters">
          <label class="filter-label">Filtros:</label>
          <div class="filter-group">
            <input
              type="number"
              v-model="buscaMatricula"
              placeholder="Matrícula (ID)"
              class="filter-input"
              @input="filtrarMatriculas"
            />
            <input 
              type="text" 
              v-model="buscaNome" 
              placeholder="Nome" 
              class="filter-input"
              @input="filtrarMatriculas"
            />
            <!-- Botão Limpar Filtros -->
            <b-button
                variant="secondary"
                class="small-filter-btn"
                @click="limparFiltros"
            >
                <i class="bi bi-funnel mr-2" title="Limpar Filtro"></i>
            </b-button>
          </div>
        </div>
  
        <!-- Tabela de Matrículas (Alunos Matriculados) -->
        <div class="table-container">
          <table class="table">
            <thead>
              <tr>
                <th>Matrícula</th>
                <th>Nome</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!matriculasFiltradas.length">
                <td colspan="5" class="text-center">Nenhum registro encontrado.</td>
              </tr>
              <tr v-else v-for="matricula in matriculasFiltradas" :key="matricula.id">
                <td>{{ matricula.id }}</td>
                <td>{{ matricula.aluno_nome }}</td>
                <td>
                  <button class="btn btn-success btn-sm" @click="selecionarMatricula(matricula)">
                    <i class="bi bi-check-lg"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
  
        <!-- Rodapé com Paginação -->
        <div class="modal-footer">
            <span class="total-registros">{{ totalRegistros }} registros</span>
            <div class="pagination-container">
                <button 
                  class="btn btn-light pagination-btn" 
                  :disabled="pagina <= 1" 
                  @click="mudarPagina(pagina - 1)"
                >
                  <i class="bi bi-chevron-left"></i>
                </button>
                <span class="pagination-text">Página {{ pagina }} de {{ totalPaginas }}</span>
                <button 
                  class="btn btn-light pagination-btn" 
                  :disabled="pagina >= totalPaginas" 
                  @click="mudarPagina(pagina + 1)"
                >
                  <i class="bi bi-chevron-right"></i>
                </button>
            </div>
        </div>
  
        <!-- Modal para cadastrar novo aluno (opcional, se necessário) -->
        <ModalCadastrarPessoaFisica 
          v-if="mostrarModalCadastrar" 
          @pessoaCadastrada="handlePessoaCadastrada" 
          @fechar="mostrarModalCadastrar = false" 
        />
      </div>
    </div>
  </template>
  
  <script>
  import { ref, computed, watch, onMounted } from "vue";
  import axios from "@/services/axios";
  import ModalCadastrarPessoaFisica from "@/components/modals/ModalCadastrarPessoaFisica.vue";
  import { BButton } from "bootstrap-vue-next";
  
  export default {
    name: "CarregarAlunos",
    components: { ModalCadastrarPessoaFisica, BButton },
    props: {
      mostrar: Boolean,
      prospeccaoId: { type: [String, Number], default: null }
    },
    emits: ["fechar", "selecionar"],
    setup(props, { emit }) {
      const buscaNome = ref("");
      const buscaCPF = ref("");
      const buscaMatricula = ref(""); // ⬅️ novo
      const matriculas = ref([]);
      const pagina = ref(1);
      const totalPaginas = ref(1);
      const totalRegistros = ref(0);
      const mostrarModalCadastrar = ref(false);
  
      const carregarMatriculas = async () => {
        try {
          const response = await axios.get(`/operacional/matriculas`, {
            params: {
              aluno: buscaNome.value || undefined,
              matricula: buscaMatricula.value ? Number(buscaMatricula.value) : undefined, // ⬅️ novo
              status: "Ativo,Trancado",
              page: pagina.value,
              sortBy: "aluno",
              sortOrder: "asc",
            },
          });
          matriculas.value = response.data.data || [];
          totalPaginas.value = response.data.totalPages || 1;
          totalRegistros.value = response.data.total || 0;
        } catch (error) {
          console.error("Erro ao carregar matrículas:", error);
          matriculas.value = [];
        }
      };
  
      const limparFiltros = () => {
        buscaNome.value = "";
        buscaCPF.value = "";
        buscaMatricula.value = ""; // ⬅️ novo
        carregarMatriculas();
      };
  
      const filtrarMatriculas = () => {
        pagina.value = 1;
        carregarMatriculas();
      };
  
      const mudarPagina = (novaPagina) => {
        if (novaPagina > 0 && novaPagina <= totalPaginas.value) {
          pagina.value = novaPagina;
          carregarMatriculas();
        }
      };
  
      const selecionarMatricula = (matriculaSelecionada) => {
        // Emite o objeto matrícula (incluindo id, aluno_id, etc.)
        emit("selecionar", { matricula: matriculaSelecionada, prospeccaoId: props.prospeccaoId });
        emit("fechar");
      };
  
      const abrirModalCadastrar = () => {
        mostrarModalCadastrar.value = true;
      };
  
      const handlePessoaCadastrada = (novaPessoa) => {
        // Após cadastrar, emite o evento com a nova matrícula se for possível
        emit("selecionar", { matricula: novaPessoa, prospeccaoId: props.prospeccaoId });
        mostrarModalCadastrar.value = false;
        carregarMatriculas();
      };
  
      // Funções de formatação para CPF/CNPJ
      const formatarCPF = (cpf) => {
        if (!cpf) return "";
        return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      };
  
      const formatarCNPJ = (cnpj) => {
        if (!cnpj) return "";
        return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
      };
  
      onMounted(() => {
        if (props.mostrar) {
          carregarMatriculas();
        }
      });
  
      watch(() => props.mostrar, (novoValor) => {
        if (novoValor) {
          limparFiltros();
        }
      });
  
      const matriculasFiltradas = computed(() => matriculas.value);
  
      return {
        buscaNome,
        buscaCPF,
        matriculas,
        pagina,
        totalPaginas,
        totalRegistros,
        filtrarMatriculas,
        limparFiltros,
        mudarPagina,
        selecionarMatricula,
        abrirModalCadastrar,
        mostrarModalCadastrar,
        handlePessoaCadastrada,
        formatarCPF,
        formatarCNPJ,
        matriculasFiltradas,
        buscaMatricula,
      };
    },
  };
  </script>
  
  <style scoped>
  
  /* Ajusta o cabeçalho do modal */
    /* Cabeçalho do modal */
    .modal-header {
      background: #ccc; /* cor cinza */
      padding: 10px 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  
  
    /* Estilos gerais do modal */
    .modal-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  
    .modal-container {
    background: #fff;
    width: 100%;
    max-width: 700px; /* ajuste conforme necessário */
    height: 600px; /* define a altura fixa */
    overflow-y: auto; /* adiciona barra de rolagem vertical se necessário */
    margin: 0 10px;
    border-radius: 4px;
    /* Remova margens duplicadas se estiverem interferindo */
  }
  
      /* Conteúdo do modal */
      .modal-content {
      padding: 15px;
    }
  
  
  .modal {
    display: block;
    background: white;
    width: 60%;
    max-width: 90%;
    max-height: 80%;
    overflow-y: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  
    /* Ícone de fechar */
    .close-icon {
      font-size: 1.5rem;
      cursor: pointer;
    }
  
  
  /* Barra de pesquisa */
  .modal-filters {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .filter-label {
    font-size: 12px;
    font-weight: bold;
    color: #333;
    margin-top: 10px;
    margin-left: 10px;
  }
  
  .filter-group {
    display: flex;
    flex-grow: 1;
    gap: 10px;
    margin-right: 40px;
  }
  
  .filter-input {
    flex: 1;
    padding: 8px 10px;
    border: 1px solid #ccc;
    border-radius: 0px;
    font-size: 10px;
    outline: none;
    transition: 0.2s;
    margin-left: 8px;
    margin-right: 15px;
  }
  
  .filter-input:focus {
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.3);
  }
  
  /* Tabela */
  .table-container {
    margin-top: 15px;
    margin-left: 15px;
    margin-right: 15px;
  }
  
  /* Ajusta a altura das células e centraliza verticalmente os conteúdos */
  .table th, .table td {
    padding: 8px 10px; /* Reduz um pouco o espaçamento */
    line-height: 1.2; /* Ajusta a altura da linha */
    vertical-align: middle; /* Centraliza verticalmente */
  }
  
  .table td .btn-sm {
    padding: 4px 6px; /* Reduz o padding */
    font-size: 0.85rem; /* Diminui um pouco o tamanho do texto */
    height: 15px; /* Ajusta a altura */
    width: 15px; /* Mantém o botão quadrado */
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .table th {
    background: #f1f1f1;
    font-weight: bold;
  }
  
  .table td {
    padding: 8px;
    border-bottom: 1px solid #ddd;
  }
  
  /* Rodapé */
  /* 🔹 Ajusta a paginação e centraliza no Modal */
  .modal-footer {
    display: flex;
    justify-content: center; /* Centraliza a paginação */
    align-items: center;
    margin-top: 10px;
    padding-top: 10px;
  }
  
  /* 🔹 Ajusta o layout da paginação */
  .pagination-container {
    display: flex;
    align-items: center;
    gap: 10px; /* Espaço entre os elementos */
  }
  
  /* 🔹 Estiliza os botões de navegação da paginação */
  .pagination-btn {
    padding: 6px 10px;
    font-size: 14px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  /* 🔹 Estiliza o texto de página */
  .pagination-text {
    font-size: 12px;
    font-weight: normal;
    color: #333;
  }
  
  /* 🔹 Ajusta a área de registros */
  .total-registros {
    position: absolute;
    left: 20px;
    font-size: 14px;
    color: #555;
  }
  
  /* Ajusta a barra de filtros */
  .modal-filters {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 15px;
  }
  
  /* Ajusta o grupo de filtros */
  .filter-group {
    display: flex;
    flex-grow: 1;
    gap: 10px;
    align-items: center;
  }
  
  /* Estiliza o botão de limpar filtros */
  .filter-btn {
    background: #6c757d;
    border: none;
    color: white;
    padding: 6px 12px;
    font-size: 16px;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .filter-btn i {
    font-size: 18px;
  }
  
  .filter-btn:hover {
    background: #1a1b1b;
  }
  
  .small-filter-btn {
    padding: 7px 10px;      /* Reduz o espaçamento interno */
    font-size: 12px;       /* Fonte menor para o botão */
    line-height: 1;
  }
  
  .small-filter-btn i {
    font-size: 10px;       /* Diminui o tamanho do ícone, se desejar */
  }
  
  
    </style>  